import { useEffect, useState } from "react";
import api from "@/lib/api";
import { motion } from "framer-motion";
import { Users, TrendingUp, MessageSquare, Loader2 } from "lucide-react";

const CARDS = [
  { key: "leads_today", title: "Redirecciones Hoy", testid: "metric-total-leads-value", icon: MessageSquare, suffix: "" },
  { key: "active_reps", title: "Vendedores Activos", testid: "metric-active-reps-value", icon: Users, suffix: "" },
  { key: "confirmed", title: "Contactos Confirmados", testid: "metric-confirmed-value", icon: MessageSquare, suffix: "" },
  { key: "contact_rate", title: "Tasa de Confirmación", testid: "metric-conversion-rate-value", icon: TrendingUp, suffix: "%" },
];

export default function AdminDashboard() {
  const [m, setM] = useState(null);

  useEffect(() => {
    api.get("/metrics").then(({ data }) => setM(data)).catch(() => setM({}));
  }, []);

  if (!m)
    return <div className="flex justify-center py-20"><Loader2 className="w-7 h-7 text-[#25D366] animate-spin" /></div>;

  return (
    <div>
      <h1 className="font-heading text-2xl sm:text-3xl font-extrabold text-slate-50 mb-1">Panel de control</h1>
      <p className="text-slate-400 mb-6">Resumen de tu reparto de leads en tiempo real</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
        {CARDS.map((c, i) => {
          const Icon = c.icon;
          return (
            <motion.div
              key={c.key}
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.06 }}
              className="bg-[#111822] border border-[#1E2D3D] rounded-xl p-5 relative overflow-hidden"
            >
              <div className="absolute top-0 right-0 w-24 h-24 bg-[#25D366]/5 rounded-full blur-2xl" />
              <div className="flex items-center justify-between mb-4">
                <span className="text-xs font-mono-lf uppercase tracking-widest text-slate-500">{c.title}</span>
                <Icon className="w-5 h-5 text-[#25D366]" />
              </div>
              <p data-testid={c.testid} className="font-heading text-4xl font-extrabold text-slate-50 font-mono-lf">
                {m[c.key] ?? 0}{c.suffix}
              </p>
            </motion.div>
          );
        })}
      </div>

      <div className="mt-6 bg-[#111822] border border-[#1E2D3D] rounded-xl p-5">
        <span className="text-xs font-mono-lf uppercase tracking-widest text-slate-500">Total histórico</span>
        <p className="font-heading text-2xl font-bold text-slate-100 mt-2">
          {m.redirected ?? 0} redirigidos &middot; {m.confirmed ?? 0} confirmados &middot; {m.total_reps ?? 0} vendedores
        </p>
        <p className="text-xs text-slate-500 mt-2">
          Una redirección registra el clic al chat; el vendedor la marca como "Contacto confirmado" cuando el cliente escribe.
        </p>
      </div>
    </div>
  );
}
